import React, { useState, useEffect } from 'react';
import styles from './Hero.module.css';

const Hero = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [showScrollIndicator, setShowScrollIndicator] = useState(true);

  const translations = {
    en: {
      title: "Welcome to The Queens Hotel",
      text: [
        "We are delighted to welcome you to our family-run hotel in the heart of historic Harlech. Whether you're popping in for a drink, joining us for a meal, or planning a stay, we've worked hard to create a warm, relaxed space where everyone feels at home. Our modern rooms offer a comfortable base for exploring the area, with pet-friendly options, impressive views, and everything you need for a great night's rest.",
        "Harlech is a special place, with its iconic castle, sweeping coastline, and endless walking trails — and we feel lucky to share it with our guests. Whether you're here for a short break or just passing through, we hope you'll enjoy everything our pub, hotel, and the beautiful surroundings have to offer."
      ],
      signature: "Rachel & Liam",
      buttonText: "Cymraeg"
    },
    cy: {
      title: "Croeso i Westy'r Queens",
      text: [
        "Rydym wrth ein bodd yn eich croesawu i'n gwesty teuluol yng nghanol hanesyddol Harlech. P'un a ydych chi'n galw heibio am ddiod, yn ymuno â ni am bryd o fwyd, neu'n cynllunio arhosiad, rydym wedi gweithio'n galed i greu gofod cynnes, hamddenol lle mae pawb yn teimlo gartref. Mae ein hystafelloedd modern yn cynnig sylfaen gyfforddus ar gyfer archwilio'r ardal, gydag opsiynau sy'n groesawgar i anifeiliaid anwes, golygfeydd trawiadol, a phopeth sydd ei angen arnoch am noson dda o orffwys.",
        "Mae Harlech yn lle arbennig, gyda'i gastell eiconig, arfordir helaeth, a llwybrau cerdded diddiwedd - ac rydym yn teimlo'n lwcus i'w rannu gyda'n gwesteion. P'un a ydych chi yma am seibiant byr neu'n pasio heibio, rydym yn gobeithio y byddwch chi'n mwynhau popeth sydd gan ein tafarn, gwesty, a'r amgylchedd hardd i'w gynnig."
      ],
      signature: "Rachel a Liam",
      buttonText: "English"
    }
  };

  const toggleLanguage = () => {
    setCurrentLanguage(currentLanguage === 'en' ? 'cy' : 'en');
  };

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setShowScrollIndicator(false);
    }
  };

  const scrollToContent = () => {
    const nextSection = document.querySelector('.App main > *:nth-child(2)');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const currentTranslation = translations[currentLanguage];

  return (
    <div className={styles.hero}>
      <div 
        className={styles['hero-image']} 
        data-testid="hero-image"
        style={{
          background: 'linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(/website_images/external_side.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        {/* Hero background image */}
      </div>
      <div className={styles['hero-content']}>
        <div className={styles['language-toggle']}>
          <span 
            className={styles['lang-toggle']} 
            onClick={toggleLanguage}
          >
            {currentTranslation.buttonText}
          </span>
        </div>
        <h1>{currentTranslation.title}</h1>
        <div className={styles['hero-text']}>
          {currentTranslation.text.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
        <div className={styles['hero-signatures']}>
          <div className={styles['hero-signature']}>{currentTranslation.signature}</div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      {showScrollIndicator && (
        <button 
          className={styles['scroll-indicator']}
          onClick={scrollToContent}
          aria-label="Scroll to content"
        >
          <div className={styles['scroll-chevrons']}>
            <span className={styles['chevron']}>‹</span>
            <span className={styles['chevron']}>‹</span>
            <span className={styles['chevron']}>‹</span>
          </div>
        </button>
      )}
    </div>
  );
};

export default Hero;